<template>
    <div>
        <form class="login" @submit.prevent="register">
            <!-- <h1>REGISTRÁCIA</h1> -->

            <!--<label>Username</label>-->
            <!-- <input required v-model="username" type="text" placeholder="meno"/> -->
            <b-field >
              <b-input v-model="username" placeholder="meno"></b-input>
            </b-field>
            <br>
            <!--<label>e-mail</label>-->
            <!-- <input required v-model="email" type="text" placeholder="e-mail"/> -->
            <b-field >
              <b-input v-model="email" placeholder="e-mail"></b-input>
            </b-field>
            <br>
            <!--<label>heslo</label>-->
            <!-- <input required v-model="password" type="password" placeholder="heslo"/> -->
            <b-field >
              <b-input v-model="password" placeholder="heslo"></b-input>
            </b-field>
            <br>
            <!--<label>zopakuj heslo</label>-->
            <!-- <input required v-model="passwordrep" type="password" placeholder="opakuj heslo"/> -->
            <b-field >
              <b-input v-model="passwordrep" placeholder="opakuj heslo"></b-input>
            </b-field>
            <br/>
            <!-- <button type="submit">REGISTROVAT</button> -->
            <div class="buttons my-center-horizontal" type="submit">

            <button class="button is-primary" type="submit">
              <strong>REGISTROVAT</strong>
            </button>
          </div>
            
        </form>
        
    </div>
</template>


<script>

    // import { AUTH_REQUEST, AUTH_LOGOUT } from '../../store/actions/auth'

    export default {

      name: 'register',
      data () {
        return {
          username: '',
          email: '',
          password: '',
          passwordrep: '',
        }
      },
      methods: {
        register: function () {
          console.log('register pressed ...TODO')
        }
        // login: function () {
        //   const { username, password } = this;
        //   this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
        //     this.$router.push('/user/xxx/dashboard')
        //   })
        // },
        // logout: function () {
        //   this.$store.dispatch(AUTH_LOGOUT).then(() => {
        //     this.$router.push('/')
        //   })
        // }
      }
    }

</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-center-horizontal {
    display: block;
  }
</style>
